var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VCard',{staticClass:"pa-4 rounded-lg",attrs:{"outlined":"","color":"am-blue-lighten-97"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }